module.exports = __webpack_public_path__ + "img/nft.da01a2ce.svg";